module.exports = __webpack_public_path__ + "img/color7.6784993c.png";